var _style, _defs, _defs2, _defs3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs4, _path8, _path9, _path0, _path1, _defs5, _path10, _defs6, _path11, _defs7, _path12, _path13, _path14, _defs8, _path15, _path16, _path17, _path18, _defs9, _path19, _path20, _path21, _path22, _path23, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMySummaryOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_287_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.8 99",
    style: {
      enableBackground: "new 0 0 105.8 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000075849403120863742930000011987666312599280011_);}\n\t.st1{clip-path:url(#SVGID_00000006695982541178731030000016678667164658475150_);}\n\t.st2{clip-path:url(#SVGID_00000116216397027262903490000000311248435472170658_);}\n\t.st3{fill:#F1A8BA;}\n\t.st4{fill:#141F45;}\n\t.st5{fill:#00C9D3;}\n\t.st6{opacity:0.15;}\n\t.st7{clip-path:url(#SVGID_00000008831444961031903310000011523902527501032625_);}\n\t.st8{fill:#250B11;}\n\t.st9{fill:#009CDD;}\n\t.st10{fill:#20C5A0;}\n\t.st11{opacity:0.4;}\n\t.st12{clip-path:url(#SVGID_00000137129400999391499980000011543228514185415609_);}\n\t.st13{fill:#FFFFFF;}\n\t.st14{clip-path:url(#SVGID_00000048482862077938130060000014891286726775338167_);}\n\t.st15{clip-path:url(#SVGID_00000040543780216236492930000009567642972172696996_);}\n\t.st16{clip-path:url(#SVGID_00000049196932251499662320000003655448813766259364_);}\n\t.st17{fill:#11172D;}\n\t.st18{clip-path:url(#SVGID_00000147899175003243662230000002846759476905673904_);}\n\t.st19{fill:#17171F;}\n\t.st20{fill:#143B6E;}\n\t.st21{fill:#E26A83;}\n\t.st22{fill:#765F59;}\n\t.st23{fill:#E55757;}\n\t.st24{fill:#ED9F0E;}\n\t.st25{fill:#FFD958;}\n\t.st26{fill:none;stroke:#C1C1C1;stroke-width:0.746;}\n\t.st27{fill:#707070;}\n\t.st28{fill:none;stroke:#E6E6E6;stroke-width:0.746;stroke-linecap:round;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.3,
    y: -0.5,
    width: 412,
    height: 99
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075843768192003108410000000102939778702225316_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    transform: "translate(-0.333 -0.463)",
    style: {
      clipPath: "url(#SVGID_00000075843768192003108410000000102939778702225316_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_277_6",
    transform: "translate(14.333)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000148627631424349334730000000135168288278746551_",
    x: 0,
    y: 0,
    width: 73,
    height: 166.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062882306827379243830000016529355286289255566_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148627631424349334730000000135168288278746551_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    style: {
      clipPath: "url(#SVGID_00000062882306827379243830000016529355286289255566_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000046317424775023364380000011687477587880928691_",
    x: 0,
    y: 0,
    width: 73,
    height: 166.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028300430638958356380000003290248446391542688_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046317424775023364380000011687477587880928691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    style: {
      clipPath: "url(#SVGID_00000028300430638958356380000003290248446391542688_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    className: "st3",
    d: "M9.6,152.8l-1,6.7c0.2,4.1,2.9,3.7,5.9,2.5l2.9-5.5L9.6,152.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    className: "st4",
    d: "M8.6,159.5l-1.1,5.6c-0.2,0.8,0.4,1.6,1.2,1.8c0.1,0,0.2,0,0.3,0h15.8 c0,0,0-4.1-2-4.9s-6.8-0.2-7-2.5H13c0,0,0.2,3.1-1.8,2.5C9.9,161.6,8.9,160.7,8.6,159.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    className: "st3",
    d: "M37.2,152.8l1.1,6.7c0.2,4.1,2.9,3.7,5.9,2.5l0.9-6.6L37.2,152.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    className: "st4",
    d: "M38.3,159.5l-1.1,5.6c-0.2,0.8,0.4,1.6,1.2,1.8l0,0c0.1,0,0.2,0,0.3,0h15.8 c0,0,0-4.1-2-4.9s-6.8-0.2-7-2.5h-2.8c0,0,0.2,3.1-1.8,2.5C39.7,161.6,38.7,160.7,38.3,159.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    className: "st5",
    d: "M44.9,75.1L46.2,91l1.6,24.9c0.1,2.2,1.2,5.2,0,7.2l-1.7,35.1l-8.6-0.8 c0,0-6.4-32-2.2-42l-5.3-25l1.2-5.5L44.9,75.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    className: "st5",
    d: "M14.9,75.3l-1.2,10c-0.2,1.6-0.2,3.2,0,4.7l2.6,25c0,0-5.3,12.4-7.7,40.8l9.1,3.1 l11.2-37.7c0.9-1.3,1.5-2.8,1.6-4.3l1.8-28c7.2-2.2,11.5-6.7,12.7-13.6L14.9,75.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    className: "st3",
    d: "M54.9,42.7l2.4,6.5l7.6-18.9l4.2,1.7c0,0-5.5,26.6-9.8,29.2S44.8,44.5,44.8,44.5 L54.9,42.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150810444623944767760000000876147418064234420_",
    x: 44.8,
    y: 42.7,
    width: 17.1,
    height: 18.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067928679853465663260000013137378077926527653_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150810444623944767760000000876147418064234420_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    style: {
      clipPath: "url(#SVGID_00000067928679853465663260000013137378077926527653_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    className: "st8",
    d: "M44.8,44.5l10.1-1.9l0.9,2.4c-0.4,0.1-1,0.2-1.4,0.3c-0.6,0.2-1.3,0.5-1.9,0.8 c-1.3,0.7-2.2,2-2.5,3.5c-0.2,1.9,1.2,3.6,2.4,5.1l3.3,3.8c0.7,0.8,1.6,1.7,2.7,1.6c0.9-0.2,1.7-0.8,2.3-1.6 l1.1-1.3c-0.9,2-1.8,3.4-2.6,3.9C55,63.8,44.8,44.5,44.8,44.5"
  }))))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    className: "st9",
    d: "M32.3,26.4c0,0-21-1.1-22.2,0S0,44.6,0,44.6c1.3,1.5,3,2.6,4.9,3.2 c2.9,0.8,11.1,1,11.1,1l-2.1,25.4c0,0.5,0.4,1,0.9,1.1l0,0h0.1L45,75.2c0.5,0,1-0.4,1-1l1.1-28l8.9-4 c0,0-5.5-13.1-6.7-13.7S32.3,26.4,32.3,26.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    className: "st9",
    d: "M32.3,26.4c0,0-21-1.1-22.2,0S0,44.6,0,44.6c1.3,1.5,3,2.6,4.9,3.2 c2.9,0.8,11.1,1,11.1,1l-2.1,25.4c0,0.5,0.4,1,0.9,1.1l0,0h0.1L45,75.2c0.5,0,1-0.4,1-1l1.1-28l8.9-4 c0,0-5.5-13.1-6.7-13.7S32.3,26.4,32.3,26.4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    className: "st10",
    d: "M32.3,26.4c0,0-21-1.1-22.2,0S0,44.6,0,44.6c1.3,1.5,3,2.6,4.9,3.2 c2.9,0.8,11.1,1,11.1,1l-2.1,25.4c0,0.5,0.4,1,0.9,1.1l0,0h0.1L45,75.2c0.5,0,1-0.4,1-1l1.1-28l8.9-4 c0,0-5.5-13.1-6.7-13.7S32.3,26.4,32.3,26.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158742994156476144790000006051275402011818379_",
    x: 36.5,
    y: 26.9,
    width: 19.4,
    height: 15.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168813691680737229760000008560992169746934196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158742994156476144790000006051275402011818379_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    style: {
      clipPath: "url(#SVGID_00000168813691680737229760000008560992169746934196_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    className: "st13",
    d: "M49.2,28.5c-0.8-0.4-7.7-1.1-12.5-1.6c-0.1,0-0.2,0.1-0.2,0.1l7.2,1.1 c2.6-0.1,4.9,1.6,5.7,4.1l5.3,10.6l1.2-0.5C55.9,42.2,50.4,29.1,49.2,28.5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000089545322192409116150000011537077394646506403_",
    x: 33.8,
    y: 31.6,
    width: 14.2,
    height: 43.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078747736285427813100000000175331821521181611_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089545322192409116150000011537077394646506403_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    style: {
      clipPath: "url(#SVGID_00000078747736285427813100000000175331821521181611_)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    className: "st13",
    d: "M43.3,71.4c3-3.8,1.6-22.6,2.5-32.5S48,32,48,32l-1,14.2l0,0v1.3l-1,26.7 c0,0.5-0.5,1-1,1H33.9C33.8,75.2,40.2,75.1,43.3,71.4"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155121986940979544520000005326277611754724025_",
    x: 0,
    y: 26,
    width: 38.1,
    height: 130.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035504115760962437040000006174742746137047485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155121986940979544520000005326277611754724025_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    style: {
      clipPath: "url(#SVGID_00000035504115760962437040000006174742746137047485_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    className: "st8",
    d: "M9.7,48.4c0.5,0,0.9,0.1,1.4,0.1h0.5h0.2h0.4h0.2h0.4H13c0.7,0,1.3,0.1,1.8,0.1 h0.1c0.6,0,1,0,1,0L13.8,74c0,0.1,0,0.2,0,0.3c0.1,0.4,0.5,0.8,1,0.8l-0.1,1.2l-1.1,8.8c0,0.2,0,0.4-0.1,0.5v0.1 c0,0.4-0.1,0.8-0.1,1.1c0,0.2,0,0.4,0,0.6c0,0.4,0,0.8,0,1.2c0,0.2,0,0.4,0,0.6s0,0.4,0.1,0.6l2.6,25 c0,0-5.3,12.4-7.7,40.8l2.3,0.8c3.7-13.7,9.1-40.7,9.6-40.7c4.2,0.1,0-9.9,0-9.9c-1.5-3.6,0.2-7.4-0.4-12.5 c-0.3-3.2,2.5-12.3,1.5-15.2c-0.6-1.5,11.5-1.5,11-3c-0.5-1.4-13.7-4.5-14.1-6c-2.9-10.7,1-22.2,6.6-31.8 c0.7-1.4,1.7-2.7,2.8-3.8c1-0.9,2.1-1.7,3.2-2.3l5.6-3.5c0.4-0.2,0.9-0.5,1.5-0.8h-0.3h-0.1h-0.3l0,0l-1.4-0.1l0,0 c-1-0.1-1.8-0.2-2.5-0.2l0,0h-0.1l0,0h-0.4h-0.1l0,0h-0.4h-0.1l0,0c0,0-21-1.1-22.2,0c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.2,0.3-0.6,0.9-1,1.6l-0.2,0.3c-0.1,0.2-0.2,0.4-0.3,0.6l-0.2,0.3C5.2,34.6,0,44.6,0,44.6 c0.2,0.2,0.4,0.5,0.7,0.7l0.1,0.1c0.2,0.2,0.5,0.4,0.8,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.4,0.3,0.6,0.4 c0.3,0.2,0.7,0.4,1,0.5c0.1,0,0.2,0.1,0.2,0.1c0.3,0.1,0.5,0.2,0.8,0.3c0.1,0,0.2,0.1,0.3,0.1c1,0.2,2,0.4,3,0.5 C8.5,48.3,9.1,48.4,9.7,48.4"
  }))))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    className: "st4",
    d: "M5.8,48c-0.3-0.1-0.7-0.1-0.9-0.2C3,47.2,1.3,46.1,0,44.6C1.3,45.5,2.9,46,4.5,46 C5.4,46.1,5.8,46.9,5.8,48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    className: "st3",
    d: "M40.8,11.7c-0.4,1.6-0.6,3.2-0.8,4.8c-0.2,2-0.5,4.3-3.2,5.2s-2.3,0.6-2.3,0.6 c-0.1,1.9,1,3,1.7,4.6c-2.5,1.9-5.9,2-8.6,0.4l-1.6-1c0,0,2.8-5.2,1.8-7.5S27,11.4,27,11.4s0.8-2.1,4.2-2.7 C34.4,7.8,41.8,5.7,40.8,11.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_680"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177477381070929357210000014468619118988880047_",
    x: 34.7,
    y: 10.3,
    width: 6.2,
    height: 11.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139295505596672669710000016435416258640918961_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177477381070929357210000014468619118988880047_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    style: {
      clipPath: "url(#SVGID_00000139295505596672669710000016435416258640918961_)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    className: "st13",
    d: "M35.2,21.6c0.8-0.6,2-0.6,2.7-1.3c0.5-0.6,0.7-1.3,0.6-2 c0-0.7-0.2-1.4-0.3-2.2c-0.1-0.7,0-1.5,0.4-2.1s1.1-1,1.3-1.8c0.1-0.5,0.1-1.5,0.7-1.8c0.1-0.1,0.2-0.1,0.4,0 c0,0.4,0,0.9-0.1,1.3c-0.4,1.6-0.6,3.2-0.8,4.8c-0.2,2-0.5,4.3-3.2,5.2c-1.2,0.4-1.8,0.6-2.1,0.6 C34.8,22,35,21.7,35.2,21.6"
  }))))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    className: "st17",
    d: "M16.4,47.5L16.4,47.5c-0.1,0-0.2-0.1-0.2-0.2c1.9-12.1-1-16.8-1-16.8 c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0l0,0c0.1,0.2,3,4.8,1.1,17.1C16.6,47.4,16.5,47.5,16.4,47.5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    className: "st17",
    d: "M46.9,44.5L46.9,44.5c-0.1,0-0.2-0.1-0.2-0.2L47.8,32c0-0.1,0.1-0.2,0.2-0.2 c0.1,0,0.2,0.1,0.2,0.2l0,0l-1.1,12.3C47.1,44.4,47,44.5,46.9,44.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    className: "st3",
    d: "M39.7,66.3c0,0-25.8,5.2-26.5,3.5c-3.5-7.7-6.4-15.6-8.7-23.7 c11-2.5,11.5,2.3,11.5,2.3l2.7,15.4l19.8-1.7c-0.1-1.1,0.4-2.2,1.2-2.9l1.6-3c0.1-0.4,0.4-0.7,0.9-0.7 c0.4,0,0.7,0.4,0.7,0.7L42,58.5l3.8-1.8l3.6,0.1c0.4,0,0.8,0.4,0.7,0.8c0,0.4-0.3,0.7-0.7,0.7l0,0l-2.5,0.1L46,59 l0.4,0.1c0.6,0.1,0.9,0.7,0.8,1.3c-0.1,0.5-0.6,0.8-1.1,0.8h-0.5v0.3l0.6,0.2c0.3,0.1,0.5,0.5,0.4,0.8v0.1 c-0.1,0.3-0.4,0.6-0.8,0.5l-1-0.1l-0.1,0.3l0.3,0.1c0.4,0.1,0.5,0.5,0.4,0.9c0,0.1-0.1,0.1-0.1,0.2 c-0.2,0.2-0.4,0.3-0.7,0.2l-0.9-0.2C43.8,64.5,41.2,66.3,39.7,66.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119082873890432919600000008615956867469613739_",
    x: 4.5,
    y: 45.4,
    width: 44.9,
    height: 24.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096030985314732988230000014464885771470490021_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119082873890432919600000008615956867469613739_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    style: {
      clipPath: "url(#SVGID_00000096030985314732988230000014464885771470490021_)"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    className: "st8",
    d: "M16,48.4L16,48.4c-1-0.1-2-0.8-3.1-0.9c-1.3-0.1-2.6,0.1-3.7,0.7l4.5,14.4 c0.5,1.7,1.2,3.6,2.8,4.4c1.3,0.5,2.7,0.6,4.1,0.3l12.9-1.9c2.9-0.4,5.9-0.9,8-2.8c1.1-1,1.8-2.2,2.9-3.3 c1-1.1,2.4-1.7,3.9-1.5c0.4,0.1,0.8,0.3,1.1,0.5l0,0l-2.5,0.1L46,59l0.4,0.1c0.6,0.1,0.9,0.7,0.8,1.3 c-0.1,0.5-0.6,0.8-1.1,0.8h-0.5v0.3l0.6,0.2c0.3,0.1,0.5,0.5,0.4,0.8v0.1c-0.1,0.3-0.4,0.6-0.8,0.5l-1-0.1l-0.1,0.3 l0.3,0.1c0.4,0.1,0.5,0.5,0.4,0.9c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.2l-0.9-0.2c0,0-2.6,1.8-4.1,1.7 c0,0-25.8,5.2-26.5,3.5C9.6,62,6.7,54.1,4.4,46C15.5,43.6,16,48.4,16,48.4"
  }))))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    className: "st19",
    d: "M26.1,4.5c3-1.2,10.7-1.4,11.3-4.5c0,0,4.5,1.7,4.7,5.2c0.2,1.4-0.1,2.8-0.9,4 c0.7,1.9-0.9,4.5-0.9,4.5c0.1-1.2-0.1-2.4-0.7-3.5c-0.4,0.1-0.8,0.1-1.3,0c-2.1-0.4-4.1-1-6-1.8l0.9,1.7 c0.7,1.4,0.2,3.1-1.1,3.9l-0.3,4c0,0-0.6-3.9-2.5-3.3s-1.7,3.3-0.5,3.9h-1c-2.5-2.5-4-5.8-4-9.4 C23.9,9.2,23.1,5.7,26.1,4.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    className: "st20",
    d: "M36,25.2c0,0-3.9,2.8-9.9-0.8l-1,1.8c0,0,1.8,2.6,6.5,2.7c2,0.1,4-0.6,5.4-2 L36,25.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    className: "st3",
    d: "M65,30.7c0,0-1.9-3.3-1.9-5.3V21c0-0.4,0.4-0.8,0.8-0.8s0.7,0.3,0.8,0.7L65,23 c0,0.3,0.3,0.5,0.6,0.5c0.2,0,0.4-0.2,0.5-0.5l1.2-7c0.1-0.5,0.5-0.8,1-0.7h0.1c0.4,0.1,0.7,0.5,0.7,0.9l-0.4,4.2 c0.6,0,1.2,0,1.8,0.1c0.3,0.4,0.5,0.8,0.6,1.2c0.1,0.2,0.3,0.4,0.5,0.5h0.1c0.3,0.1,0.5,0.3,0.6,0.5l0.2,0.8 c0.1,0.2,0.2,0.4,0.4,0.5c0.3,0.2,0.4,0.5,0.4,0.8l-0.4,1.8L69,32.2L65,30.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    className: "st21",
    d: "M67.6,27.8c0.7-1,0.4-2.4-0.6-3.1c-0.3-0.2-0.4-0.6-0.2-0.9l1.8-3.3l-1.3,3.1 c-0.2,0.4,0,0.8,0.4,1c0.1,0,0.2,0.1,0.3,0.1l0,0c0.6-0.1,1.2-1.2,1.5-1.8c0-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0.2,0.1,0.2 s0,0,0,0.1c-0.3,0.3-1.2,1.4-1.1,1.8s0.3,0.9,1.8-0.1c-0.3,0.2-0.6,0.5-0.8,0.8c-0.2,0.5-0.2,0.9,0.9,0.7 c0.7-0.2,1.4-0.6,1.9-1.2l0.4,0.6l-0.2,1C72.6,26.8,68.9,26,67.6,27.8"
  }))))))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphs",
    transform: "translate(-1441 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    x: 1498.4,
    y: 213.9,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1056.714 1701.4053)",
    className: "st22",
    width: 47,
    height: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    x: 1539.6,
    y: 218.6,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1089.8984 1712.3689)",
    className: "st23",
    width: 10.4,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    x: 1538,
    y: 229,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1078.3412 1719.5115)",
    className: "st24",
    width: 10.4,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    x: 1536.4,
    y: 239.3,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1066.7839 1726.6541)",
    className: "st10",
    width: 10.4,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    x: 1534.8,
    y: 249.6,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1055.2267 1733.7966)",
    className: "st25",
    width: 10.4,
    height: 2.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    x: 1500.9,
    y: 216.5,
    transform: "matrix(0.1539 -0.9881 0.9881 0.1539 1056.3013 1701.6603)",
    className: "st13",
    width: 41.8,
    height: 35.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    className: "st26",
    x1: 1509.5,
    y1: 215.9,
    x2: 1539,
    y2: 220.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    className: "st26",
    x1: 1509,
    y1: 219.6,
    x2: 1538.4,
    y2: 224.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    className: "st26",
    x1: 1508.3,
    y1: 224,
    x2: 1537.8,
    y2: 228.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    className: "st26",
    x1: 1507.6,
    y1: 228.4,
    x2: 1537.1,
    y2: 233
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    className: "st26",
    x1: 1506.9,
    y1: 232.8,
    x2: 1536.4,
    y2: 237.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    className: "st26",
    x1: 1506.2,
    y1: 237.3,
    x2: 1535.7,
    y2: 241.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    className: "st26",
    x1: 1505.5,
    y1: 241.7,
    x2: 1535,
    y2: 246.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    className: "st26",
    x1: 1504.8,
    y1: 246.1,
    x2: 1534.3,
    y2: 250.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    className: "st27",
    cx: 1509.5,
    cy: 215.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    className: "st27",
    cx: 1508.3,
    cy: 224,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    className: "st27",
    cx: 1509,
    cy: 219.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    className: "st27",
    cx: 1507.6,
    cy: 228.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    className: "st27",
    cx: 1506.9,
    cy: 232.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    className: "st27",
    cx: 1506.2,
    cy: 237.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    className: "st27",
    cx: 1505.5,
    cy: 241.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    className: "st27",
    cx: 1504.8,
    cy: 246.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    className: "st28",
    x1: 1508.8,
    y1: 215.8,
    x2: 1505.8,
    y2: 215.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    className: "st28",
    x1: 1508.2,
    y1: 219.4,
    x2: 1505.3,
    y2: 219
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    className: "st28",
    x1: 1507.5,
    y1: 223.9,
    x2: 1504.6,
    y2: 223.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    className: "st28",
    x1: 1506.8,
    y1: 228.3,
    x2: 1503.9,
    y2: 227.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    className: "st28",
    x1: 1506.2,
    y1: 232.7,
    x2: 1503.2,
    y2: 232.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    className: "st28",
    x1: 1505.5,
    y1: 237.1,
    x2: 1502.5,
    y2: 236.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    className: "st28",
    x1: 1504.8,
    y1: 241.6,
    x2: 1501.8,
    y2: 241.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    className: "st28",
    x1: 1504.1,
    y1: 246,
    x2: 1501.1,
    y2: 245.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySummaryOverlay);
export default __webpack_public_path__ + "static/media/mySummaryOverlay.64430764a905b9f1a96604e9e9a99f89.svg";
export { ForwardRef as ReactComponent };